export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
}

export const faqListContainerStyles = {
  width: '100%',
  maxWidth: ['900px', '900px', '1064px'],
  paddingX: '16px',
}
